import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Shield, LogOut } from "react-feather";
import { getImpersonatorSession, exitImpersonation } from "../../utils/impersonation";
import "./ImpersonationBanner.scss";

/**
 * Persistent top banner shown while a super-admin is impersonating a user.
 * Only renders when Redux `impersonation.active` is true.
 */
const ImpersonationBanner = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const active = useSelector((state) => state.impersonation?.active);

  if (!active) return null;

  const session = getImpersonatorSession();
  const target = session?.target;
  const displayName = target?.name && target.name !== target?.email
    ? `${target.name} (${target.email})`
    : target?.email || "a user";

  const handleExit = () => {
    exitImpersonation(dispatch, navigate);
  };

  return (
    <div className="impersonation-banner" role="alert" aria-live="polite">
      <div className="impersonation-banner__inner">
        <Shield size={15} className="impersonation-banner__icon" />
        <span className="impersonation-banner__text">
          You are impersonating <strong>{displayName}</strong>
        </span>
      </div>
      <button
        type="button"
        className="impersonation-banner__exit"
        onClick={handleExit}
        aria-label="Exit impersonation and return to your account"
      >
        <LogOut size={14} />
        Exit
      </button>
    </div>
  );
};

export default ImpersonationBanner;
